import { MaterialEvaluator } from "../../types/materialEvaluator";
import { compareOSVersion, isIOS } from "./UserAgent";

/**
 * iOS 11.3, 11.4 で inline要素が改行される問題の回避策
 * 将来的に動かなくなる可能性がある
 */
export function rewriteForSafari(containerSelector: string) {
  if (!isIOS() || compareOSVersion([11, 3, 0]) === -1) return;
  console.debug("rewriteForSafari");

  document.addEventListener("MathJax:ended", () => {
    console.log("MathJax:ended");
    pokeRenderer(document.querySelector(containerSelector));
  });

  /**
   * なぜか正常に描画される
   */
  function pokeRenderer(el: any) {
    const originalDisplay = el.style.display;
    el.style.display = "inline-block";
    setTimeout(() => (el.style.display = originalDisplay));
  }
}

/**
 * iOS 13.7以下で scroll できない問題を回避 KYOIKU-28884
 * DOM内のボタンに対してクリックイベントが発火されるとスクロールが可能になる
 * 将来的に動かなくなる可能性がある
 */
export function hackRendererForShortTest() {
  // v13.7以下のiOSが対象
  if (!isIOS() || compareOSVersion([13, 7, 0]) === 1) return;
  console.debug("hackRendererForShortTest");
  // 裏でクリックイベントを発行する回数。
  // 2回程度だとクリックイベントの発行でscrollできない場合があるため多めに見て5回を指定。
  let counter = 5;
  /**
   * button要素にonClick属性が付与されており、style="cursor: pointer;"が無いと
   * iOS WebView上でJavaScriptでクリック操作をしようとしてもクリックイベントが発生しないため、
   * ダミーボタンに必要な属性を追加する。。
   */
  const dummyButton = document.createElement("button");
  dummyButton.setAttribute("style", "cursor: pointer;");
  dummyButton.setAttribute("onclick", " ");
  dummyButton.innerText = " ";
  const doc = document.querySelector(".container")!;
  doc.append(dummyButton);

  dummyButton?.addEventListener("click", () => {
    // do nothing
  });

  step();

  function step() {
    if (dummyButton) {
      dummyButton.click();
      counter -= 1;
      if (counter > 0) {
        setTimeout(step, 100);
      }
      if (counter === 0) {
        dummyButton.remove();
      }
    }
  }
}

/**
 * iOS 15.0以上かつ縦書き問題で折り畳まれた選択肢を開くと画面描画が崩れる問題への対処
 * 各関数内で個別対応が必要なので、この関数では
 * - iOS15以上である
 * - 縦書きの問題であること
 * をチェックし、全ての条件に当てはまる時trueを返す
 *
 * 調査経緯
 * https://atl.dwango.co.jp/jira/browse/KYOIKU-38251
 */
export function checkIsVerticalSelectionExerciseIOS15(
  evaluator: MaterialEvaluator,
): boolean {
  // v15以上のiOSが対象
  return (
    isIOS() &&
    compareOSVersion([15, 0, 0]) !== -1 && // compareOSVersionの返り値が-1ではない = iOS15.0.0以上(iOS15.0.0の時0, iOS15.0.1以上で1が返るため)
    evaluator.material.writingMode === "vertical"
  );
}

/**
 * iOS で理解度確認モーダルのバツボタンが実機でのみずれる問題が生じた。
 * 生じたズレは https://github.o-in.dwango.co.jp/zane/kokuban/issues/1877#issuecomment-840799 で確認できる。
 *
 * この問題への対処として、この関数はiOSのときbodyのクラスにisIOS-closeButtonPositionWorkaroundを付与する。
 * このクラス名はこのワークアラウンド以外から参照しない。
 *
 * iOSでStorybookを見ることは無いと思うので、Storybookで使用しない。dev環境で確認する。
 *
 * 経緯は以下のスレッドを参照
 * https://dwango.slack.com/archives/G2HDJ119Q/p1700552513929299
 */
export function closeButtonPositionWorkaroundForIOS() {
  if (isIOS()) {
    document.body.classList.add("ios-close-button-position-workaround");
  }
}
